import React from 'react';
import { useTitle } from '../../../config/global';
import UserProfile from './Account/UserProfile';
import CompanyProfile from './Account/CompanyProfile';

const Account = () => {
    useTitle("Profile");

    return (
        <div className="d-flex gap-3">
            <div className="col-6 pe-2">
                <UserProfile />
            </div>
            <div className="col-6 ps-2">
                <CompanyProfile />
            </div>
        </div>
    );
}

export default Account;
